import type theme from '#build/ui-pro/footer'

export default {
	slots: {
		root: 'bg-secondary text-inverted pb-8 lg:pb-0',
		top: 'py-8 lg:py-12',
		bottom: 'py-8 lg:py-12',
		container: 'py-8 lg:py-4 lg:flex lg:items-center lg:justify-between lg:gap-x-3',
		left: 'flex items-center justify-center lg:justify-start lg:flex-1 gap-x-1.5 mt-3 lg:mt-0 lg:order-1',
		center: 'mt-3 lg:mt-0 lg:order-2 flex items-center justify-center',
		right: 'lg:flex-1 flex items-center justify-center lg:justify-end gap-x-1.5 lg:order-3'
	}
} satisfies Partial<typeof theme>
